/* La Novella — storefront behaviours
   Country notice · delivery by country · engraving preview + cart sync ·
   pairing add · White Friday tiers · mobile sticky add-to-cart · engraving try-it */
(function () {
  'use strict';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('ln-config').textContent); } catch (e) {}
  var isAr = (cfg.lang || '').indexOf('ar') === 0;
  var GCC = ['SA', 'KW', 'QA', 'BH', 'OM'];
  var bottles = cfg.bottleHandles || [];

  function store(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }
  function within(range) {
    if (!range) return false;
    var now = Date.now();
    return now >= Date.parse(range.start) && now <= Date.parse(range.end);
  }
  function guessCountry() {
    var c = cfg.country || '';
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz === 'Africa/Cairo') return 'EG';
    } catch (e) {}
    return c;
  }
  var country = guessCountry();

  /* ---------- Country notice ---------- */
  function initNotice() {
    var el = document.querySelector('[data-ln-notice]');
    if (!el) return;
    document.body.insertBefore(el, document.body.firstChild);
    if (country !== 'EG' || store('ln-notice-closed') === '1') return;
    el.hidden = false;
    var close = el.querySelector('[data-ln-notice-close]');
    if (close) close.addEventListener('click', function () { el.hidden = true; store('ln-notice-closed', '1'); });
  }

  /* ---------- Delivery by country ---------- */
  function initDelivery(root) {
    var select = root.querySelector('[data-ln-country]');
    var offer = root.querySelector('[data-ln-gcc-offer]');
    function zoneOf(c) {
      if (c === 'AE') return 'AE';
      if (c === 'EG') return 'EG';
      if (GCC.indexOf(c) > -1) return 'GCC';
      return 'XX';
    }
    function apply(c) {
      var zone = zoneOf(c);
      root.querySelectorAll('[data-ln-zone]').forEach(function (row) { row.hidden = row.getAttribute('data-ln-zone') !== zone; });
      if (offer) offer.hidden = !(zone === 'GCC' && within(cfg.offers && cfg.offers.gccFreeShipping));
    }
    if (select) {
      if (country && select.querySelector('option[value="' + country + '"]')) select.value = country;
      else if (country && country !== 'AE') select.value = 'XX';
      select.addEventListener('change', function () { apply(select.value); });
      apply(select.value);
    }
  }

  /* ---------- Engraving ---------- */
  function setPlate(plate, text) {
    if (!plate) return;
    var t = (text || '').trim();
    plate.textContent = t || plate.getAttribute('data-placeholder') || '';
    plate.classList.toggle('is-empty', !t);
  }
  function limitLines(value) {
    var lines = value.split(/\r?\n/);
    return lines.length > 2 ? lines.slice(0, 2).join('\n') : value;
  }
  function syncDrawer(text, on) {
    var check = document.getElementById('ln-engraving-check');
    var area = document.getElementById('ln-engraving-text');
    var hidden = document.getElementById('ln-engraving-hidden');
    var note = document.getElementById('ln-engraving-note');
    if (check) check.checked = !!on;
    if (area) area.value = on ? text : '';
    if (hidden) hidden.value = on ? text : '';
    if (note) note.style.display = on ? 'block' : 'none';
  }
  function saveEngraving(text, on) {
    var body = on
      ? { attributes: { 'Laser Engraving': 'Yes', 'Engraving Text': text }, note: text }
      : { attributes: { 'Laser Engraving': '', 'Engraving Text': '' } };
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function () { syncDrawer(text, on); }).catch(function () {});
  }
  function initEngrave(root) {
    var toggle = root.querySelector('[data-ln-engrave-toggle]');
    var body = root.querySelector('[data-ln-engrave-body]');
    var input = root.querySelector('[data-ln-engrave-input]');
    var plate = root.querySelector('[data-ln-plate]');
    var count = root.querySelector('[data-count]');
    var plateBox = plate && plate.parentNode;
    var shimmered = false;
    var form = document.getElementById(root.getAttribute('data-form-id'));

    function update() {
      if (!input) return;
      var v = limitLines(input.value);
      if (v !== input.value) input.value = v;
      setPlate(plate, v);
      if (count) {
        count.textContent = v.length + '/40';
        count.classList.toggle('is-over', v.length >= 40);
      }
      if (!shimmered && v.trim() && plateBox) {
        shimmered = true;
        plateBox.classList.add('is-shimmer');
      }
    }
    if (toggle) {
      toggle.addEventListener('change', function () {
        body.hidden = !toggle.checked;
        if (toggle.checked && input) input.focus();
        if (!toggle.checked) saveEngraving('', false);
      });
    }
    if (input) { input.addEventListener('input', update); update(); }

    if (form) {
      form.addEventListener('submit', function (evt) {
        if (form.dataset.lnSynced === '1') { form.dataset.lnSynced = ''; return; }
        var on = toggle && toggle.checked && input && input.value.trim();
        if (!on) return;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        saveEngraving(input.value.trim(), true).then(function () {
          form.dataset.lnSynced = '1';
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }, true);
    }
  }


  /* ---------- Product cards: short name + scent family ---------- */
  function handleFromUrl(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function enhanceCards(scope) {
    var fam = cfg.families || {};
    (scope || document).querySelectorAll('.card__heading a[href*="/products/"]').forEach(function (a) {
      if (a.dataset.lnDone) return;
      a.dataset.lnDone = '1';
      var name = a.textContent.trim().split(/\s[—–-]\s/)[0].trim();
      if (name) a.textContent = name;
      var f = fam[handleFromUrl(a.getAttribute('href'))];
      var heading = a.closest('.card__heading');
      if (f && heading && !heading.parentNode.querySelector('.ln-card-family')) {
        var span = document.createElement('span');
        span.className = 'ln-card-family';
        span.textContent = isAr ? f[1] : f[0];
        heading.insertAdjacentElement('afterend', span);
      }
    });
  }

  /* ---------- Cart drawer: keep engraving in sync, labels, offer bar ---------- */
  var cartState = null;
  function getCart() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; });
  }
  function decorateDrawer() {
    var drawer = cartDrawer();
    if (!drawer) return;
    var d = cfg.drawer || {};
    var eLabel = drawer.querySelector('label[for="ln-engraving-check"]');
    var gLabel = drawer.querySelector('label[for="ln-giftwrap-check"]');
    var area = drawer.querySelector('#ln-engraving-text');
    if (eLabel) eLabel.textContent = isAr ? d.engravingAr : d.engraving;
    if (gLabel) gLabel.textContent = isAr ? d.giftwrapAr : d.giftwrap;
    if (area) { area.setAttribute('placeholder', isAr ? d.placeholderAr : d.placeholder); area.setAttribute('maxlength', '40'); area.setAttribute('dir', 'auto'); }
    var footer = drawer.querySelector('.drawer__footer');
    var tpl = document.getElementById('ln-tiers-template');
    if (footer && tpl && !footer.querySelector('[data-ln-tiers]')) {
      footer.insertBefore(tpl.content.cloneNode(true), footer.firstChild);
    }
    var attrs = cartState && cartState.attributes;
    if (attrs) {
      var on = attrs['Laser Engraving'] === 'Yes' && !!attrs['Engraving Text'];
      var check = drawer.querySelector('#ln-engraving-check');
      if (on && check && !check.checked) syncDrawer(attrs['Engraving Text'], true);
      var gift = drawer.querySelector('#ln-giftwrap-check');
      if (gift && attrs['Gift Wrap'] === 'Yes') gift.checked = true;
    }
    enhanceCards(drawer);
    paintGift(drawer);
  }

  /* ---------- Explorer set with a bottle (11.11, gift season, code GIFT199) ----------
     These offers only apply when the set is in the cart, so the drawer offers to add it. */
  function giftKind() {
    var list = (cfg.offers && cfg.offers.gift) || [];
    for (var i = 0; i < list.length; i++) if (within(list[i])) return list[i].kind;
    var codes = (cartState && cartState.discount_codes) || [];
    for (var j = 0; j < codes.length; j++) if (String(codes[j].code).toUpperCase() === cfg.giftCode) return 'free';
    return '';
  }
  function paintGift(drawer) {
    var footer = drawer.querySelector('.drawer__footer');
    var old = drawer.querySelector('[data-ln-gift]');
    var kind = giftKind();
    var items = (cartState && cartState.items) || [];
    var hasBottle = items.some(function (it) { return bottles.indexOf(it.handle) > -1; });
    var hasSet = items.some(function (it) { return it.handle === 'the-explorer-collection'; });
    if (!kind || !hasBottle || hasSet || !cfg.explorerVariant || !footer) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-ln-gift') === kind) return;
    if (old) old.remove();
    var t = (cfg.giftText || {})[kind] || {};
    var box = document.createElement('div');
    box.className = 'ln-gift';
    box.setAttribute('data-ln-gift', kind);
    var p = document.createElement('p');
    p.className = 'ln-gift__msg';
    p.textContent = isAr ? t.ar : t.en;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ln-gift__btn';
    b.setAttribute('data-ln-add', cfg.explorerVariant);
    b.setAttribute('data-added', isAr ? t.addedAr : t.added);
    b.textContent = isAr ? t.btnAr : t.btn;
    box.appendChild(p);
    box.appendChild(b);
    footer.insertBefore(box, footer.firstChild);
  }

  /* ---------- Cart helpers ---------- */
  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function addToCart(variantId) {
    var drawer = cartDrawer();
    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) throw res;
      if (drawer && drawer.renderContents && res.sections) {
        res.id = Number(variantId);
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ln-pair', productVariantId: variantId });
      refreshTiers();
      return res;
    });
  }

  function initPairButtons() {
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-ln-add]');
      if (!btn) return;
      btn.setAttribute('aria-busy', 'true');
      addToCart(btn.getAttribute('data-ln-add')).then(function () {
        btn.textContent = btn.getAttribute('data-added') || 'Added';
      }).catch(function () {}).then(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- White Friday tiers ---------- */
  var tierActive = within(cfg.offers && cfg.offers.tiers);
  function paintTiers(n) {
    document.querySelectorAll('[data-ln-tiers]').forEach(function (el) {
      el.hidden = !tierActive;
      if (!tierActive) return;
      var msg = el.querySelector('[data-ln-tiers-msg]');
      var key = n <= 0 ? 't0' : n === 1 ? 't1' : n === 2 ? 't2' : 't3';
      if (msg) msg.textContent = msg.getAttribute('data-' + key) || '';
      var fill = el.querySelector('[data-ln-tiers-fill]');
      if (fill) fill.style.width = Math.min(100, (Math.max(n, 0) / 3) * 100) + '%';
      el.querySelectorAll('[data-step]').forEach(function (s) {
        s.classList.toggle('is-on', Number(s.getAttribute('data-step')) <= n);
      });
    });
  }
  function refreshTiers() {
    if (!tierActive) { paintTiers(0); return; }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        (cart.items || []).forEach(function (it) { if (bottles.indexOf(it.handle) > -1) n += it.quantity; });
        paintTiers(n);
      }).catch(function () {});
  }
  function watchDrawer() {
    var drawer = cartDrawer();
    if (!drawer || !window.MutationObserver) return;
    var t, busy = false;
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(t);
      t = setTimeout(function () {
        busy = true;
        getCart().then(function () { decorateDrawer(); if (tierActive) refreshTiers(); })
          .catch(function () {}).then(function () { setTimeout(function () { busy = false; }, 50); });
      }, 150);
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(bar) {
    var form = document.getElementById(bar.getAttribute('data-form-id'));
    if (!form) return;
    var mainBtn = form.querySelector('[name="add"]');
    var add = bar.querySelector('[data-ln-sticky-add]');
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', out);
      bar.setAttribute('aria-hidden', out ? 'false' : 'true');
      add.tabIndex = out ? 0 : -1;
      document.body.classList.toggle('ln-sticky-on', out);
    }).observe(mainBtn);
    add.addEventListener('click', function () {
      if (mainBtn.disabled) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (form.requestSubmit) form.requestSubmit(); else mainBtn.click();
    });
  }

  /* ---------- Engraving try-it (homepage) ---------- */
  function initTry(root) {
    var input = root.querySelector('[data-ln-try]');
    var plate = root.querySelector('[data-ln-plate]');
    var box = plate && plate.parentNode;
    var done = false;
    if (!input) return;
    input.addEventListener('input', function () {
      setPlate(plate, input.value.slice(0, 40));
      if (!done && box) { done = true; box.classList.add('is-shimmer'); }
    });
  }

  /* ---------- Mega menu: two picture cards beside the link columns ---------- */
  function initMega() {
    var tpl = document.getElementById('ln-mega-template');
    var list = document.querySelector('.mega-menu .mega-menu__list:not(.mega-menu__list--condensed)');
    if (!tpl || !list || list.classList.contains('ln-mega')) return;
    list.classList.add('ln-mega');
    list.appendChild(tpl.content.cloneNode(true));
  }

  /* ---------- Temple band ----------
     The two rows slide on their own; scrolling speeds them up for a moment,
     then they ease back to their resting pace. Each scent also carries its
     own hieroglyph on its card and product page. */
  /* Each scent's real emblem, as printed on its bottle (assets/ln-sym-*.svg, URLs in ln-config) */
  var SYMBOLS = cfg.symbols || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initMarquees() {
    if (reduceMotion || initMarquees.done) return;
    var bands = document.querySelectorAll('[data-ln-mq]');
    if (!bands.length || !document.getAnimations) return;
    initMarquees.done = true;
    var anims = [], rate = 1, lastY = window.scrollY, lastT = performance.now(), ticking = false;
    function collect() {
      anims = [];
      document.querySelectorAll('[data-ln-mq] .ln-mq__track').forEach(function (t) {
        t.getAnimations().forEach(function (a) { anims.push(a); });
      });
    }
    function setRate(r) {
      anims.forEach(function (a) { if (a.updatePlaybackRate) a.updatePlaybackRate(r); else a.playbackRate = r; });
    }
    function settle() {
      rate += (1 - rate) * 0.06;
      if (Math.abs(rate - 1) < 0.02) { rate = 1; setRate(1); ticking = false; return; }
      setRate(rate);
      requestAnimationFrame(settle);
    }
    collect();
    var shown = 0;
    if ('IntersectionObserver' in window) {
      var mqIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var on = e.isIntersecting;
          if (on !== !!e.target.__lnOn) { shown += on ? 1 : -1; e.target.__lnOn = on; }
          e.target.querySelectorAll('.ln-mq__track').forEach(function (t) { t.style.animationPlayState = on ? 'running' : 'paused'; });
        });
      });
      bands.forEach(function (b) { mqIO.observe(b); });
    } else shown = 1;
    window.addEventListener('scroll', function () {
      if (!shown) return;
      var now = performance.now(), y = window.scrollY;
      var v = Math.abs(y - lastY) / Math.max(16, now - lastT);
      lastY = y; lastT = now;
      if (!anims.length) collect();
      rate = Math.max(rate, Math.min(1 + v * 2.2, 5));
      setRate(rate);
      if (!ticking) { ticking = true; requestAnimationFrame(settle); }
    }, { passive: true });
  }

  /* Dark engraving band: gold dust drifting in a torch-lit chamber */
  function initChamber(band) {
    if (band.__lnChamber) return;
    band.__lnChamber = true;
    band.classList.add('ln-chamber');
    if (reduceMotion) return;
    var cv = document.createElement('canvas');
    cv.className = 'ln-chamber__dust';
    cv.setAttribute('aria-hidden', 'true');
    band.insertBefore(cv, band.firstChild);
    var torch = document.createElement('div');
    torch.className = 'ln-chamber__torch';
    torch.setAttribute('aria-hidden', 'true');
    band.insertBefore(torch, band.firstChild);
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, parts = [], visible = false;
    function size() {
      W = band.clientWidth; H = band.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = W < 750 ? 26 : 56;
      parts = [];
      for (var i = 0; i < n; i++) parts.push({ x: Math.random() * W, y: Math.random() * H, r: 0.5 + Math.random() * 1.7, vy: -(0.08 + Math.random() * 0.3), vx: (Math.random() - 0.5) * 0.2, a: 0.15 + Math.random() * 0.5, p: Math.random() * 6.28 });
    }
    size();
    window.addEventListener('resize', size);
    function draw(t) {
      if (!visible) return;
      requestAnimationFrame(draw);
      t = t / 1000;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var d = parts[i];
        d.x += d.vx + Math.sin(t + d.p) * 0.15; d.y += d.vy;
        if (d.y < -5) { d.y = H + 5; d.x = Math.random() * W; }
        ctx.globalAlpha = d.a * (0.6 + 0.4 * Math.sin(t * 2 + d.p));
        ctx.fillStyle = '#f1c876';
        ctx.beginPath(); ctx.arc(d.x, d.y, d.r, 0, 6.283); ctx.fill();
      }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        var was = visible; visible = e[0].isIntersecting;
        if (visible && !was) requestAnimationFrame(draw);
      }).observe(band);
    }
    if (finePointer) {
      band.addEventListener('pointermove', function (e) {
        var r = band.getBoundingClientRect();
        torch.style.setProperty('--x', (e.clientX - r.left) + 'px');
        torch.style.setProperty('--y', (e.clientY - r.top) + 'px');
        band.classList.add('is-lit');
      });
      band.addEventListener('pointerleave', function () { band.classList.remove('is-lit'); });
    }
  }

  /* Each scent's emblem, on its card and on its product page */
  /* Emblems are carved in with light: hidden until they come into view, then a hot
     edge cuts them out from the bottom up, they flare and settle into a soft glow.
     Without JS or with reduced motion they are simply shown. */
  var carveIO = null;
  function initCarve() {
    if (carveIO || reduceMotion || !('IntersectionObserver' in window)) return;
    carveIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        carveIO.unobserve(e.target);
        var list = e.target.hasAttribute('data-ln-mq') ? e.target.querySelectorAll('.ln-carve') : [e.target];
        Array.prototype.forEach.call(list, function (el) {
          /* left to right across the screen, like a chisel moving along a wall */
          var x = el.getBoundingClientRect().left / (window.innerWidth || 1);
          el.style.setProperty('--d', (Math.max(0, Math.min(x, 1.1)) * (list.length > 1 ? 1.4 : 0.5)).toFixed(2) + 's');
          el.classList.add('is-carved');
        });
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-ln-mq]').forEach(function (band) {
      band.querySelectorAll('.ln-mq__row:not(.ln-mq__row--alt) .ln-sym').forEach(function (el) { el.classList.add('ln-carve'); });
      carveIO.observe(band);
    });
  }
  function makeSymbol(url, extra) {
    var s = document.createElement('span');
    s.className = 'ln-scent-glyph' + (extra ? ' ' + extra : '');
    s.setAttribute('aria-hidden', 'true');
    s.style.setProperty('--sym', 'url("' + url + '")');
    var cut = document.createElement('span');
    cut.className = 'ln-sym__cut';
    var ink = document.createElement('span');
    ink.className = 'ln-sym__ink';
    cut.appendChild(ink);
    s.appendChild(cut);
    if (carveIO) { s.classList.add('ln-carve'); carveIO.observe(s); }
    return s;
  }
  function addScentGlyphs(scope) {
    (scope || document).querySelectorAll('.card__heading a[href*="/products/"]').forEach(function (a) {
      var info = a.closest('.card__information');
      if (!info || info.querySelector('.ln-scent-glyph')) return;
      var url = SYMBOLS[handleFromUrl(a.getAttribute('href'))];
      if (url) info.insertBefore(makeSymbol(url), info.firstChild);
    });
    var title = document.querySelector('.product__title');
    if (title && !title.querySelector('.ln-scent-glyph')) {
      var url2 = SYMBOLS[handleFromUrl(window.location.pathname)];
      if (url2) title.insertBefore(makeSymbol(url2, 'ln-scent-glyph--title'), title.firstChild);
    }
  }

  /* ---------- Videos over the photos ----------
     A muted loop sits on top of the photo and fades in only once it is playing,
     so the photo stays as the poster and the fallback.
     - Phones can only decode a few videos at once, so at most MAX_PLAY loops run
       together: the ones most in view (the hero and the product's own video first).
     - Nothing loads before the page itself has loaded; a file starts loading just
       before its box scrolls into view.
     - If the phone refuses autoplay (iPhone Low Power Mode), the loops start on the
       first tap anywhere.
     - A failed load is retried once instead of the video disappearing for good.
     With a mouse, product cards play on hover instead. */
  var saveData = navigator.connection && navigator.connection.saveData;
  var MAX_PLAY = finePointer ? 6 : 3;
  var vidBoxes = [], vidsReady = false, needGesture = false, schedTimer = 0;
  function makeVideo(url) {
    var v = document.createElement('video');
    v.className = 'ln-vid';
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.preload = 'none';
    v.setAttribute('data-src', url);
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    v.addEventListener('error', function () {
      if (v.__retried) { v.remove(); return; }
      v.__retried = true;
      setTimeout(function () {
        var u = v.getAttribute('data-src');
        v.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'r=1';
        if (v.__want) playVid(v);
      }, 1500);
    });
    return v;
  }
  function loadVid(v) {
    if (!v.src) { v.preload = 'metadata'; v.src = v.getAttribute('data-src'); }
  }
  function playVid(v) {
    loadVid(v);
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') needGesture = true; });
  }
  function pauseVid(v) { if (!v.paused) v.pause(); v.classList.remove('is-on'); }
  function schedule() {
    if (!vidsReady) return;
    if (document.hidden) { vidBoxes.forEach(function (b) { if (b.__lnVid) pauseVid(b.__lnVid); }); return; }
    var keep = vidBoxes.filter(function (b) { return b.__lnVid && b.__lnRatio > 0.2; })
      .sort(function (x, y) { return (y.__lnRatio + y.__lnPri) - (x.__lnRatio + x.__lnPri); })
      .slice(0, MAX_PLAY);
    vidBoxes.forEach(function (b) {
      var v = b.__lnVid;
      if (!v) return;
      v.__want = keep.indexOf(b) > -1;
      if (v.__want) playVid(v); else pauseVid(v);
    });
  }
  function scheduleSoon() { clearTimeout(schedTimer); schedTimer = setTimeout(schedule, 60); }
  var hasIO = 'IntersectionObserver' in window;
  var nearIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && vidsReady && e.target.__lnVid) { loadVid(e.target.__lnVid); nearIO.unobserve(e.target); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  var vidIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.__lnRatio = e.isIntersecting ? e.intersectionRatio : 0; });
    scheduleSoon();
  }, { threshold: [0, 0.25, 0.5, 0.75, 1] }) : null;
  function attachVideo(box, url, hover, trigger, priority) {
    if (!box || !url || box.__lnVid) return;
    var v = makeVideo(url);
    box.__lnVid = v;
    box.__lnRatio = 0;
    box.__lnPri = priority ? 1 : 0;
    box.classList.add('ln-vid-host');
    box.appendChild(v);
    if (hover && finePointer) {
      var t = trigger || box;
      t.addEventListener('mouseenter', function () { if (vidsReady) playVid(v); });
      t.addEventListener('mouseleave', function () { pauseVid(v); });
    } else if (vidIO) {
      vidBoxes.push(box);
      vidIO.observe(box);
      nearIO.observe(box);
    }
  }
  function startVideos() {
    if (vidsReady) return;
    vidsReady = true;
    document.querySelectorAll('.ln-vid-host').forEach(function (b) { if (nearIO) { nearIO.unobserve(b); nearIO.observe(b); } });
    schedule();
  }
  (function () {
    if (document.readyState === 'complete') setTimeout(startVideos, 300);
    else { window.addEventListener('load', function () { setTimeout(startVideos, 300); }); setTimeout(startVideos, 4000); }
    document.addEventListener('visibilitychange', schedule);
    function onGesture() { if (needGesture) { needGesture = false; vidBoxes.forEach(function (b) { if (b.__lnVid) b.__lnVid.pause(); }); schedule(); } }
    document.addEventListener('touchend', onGesture, { passive: true });
    document.addEventListener('click', onGesture);
  })();
  function initVideos() {
    var vids = cfg.videos || {};
    if (reduceMotion || saveData || !Object.keys(vids).length) return;
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      var url = a && vids[handleFromUrl(a.getAttribute('href'))];
      if (url) attachVideo(card.querySelector('.card__media .media'), url, true, card);
    });
    document.querySelectorAll('.ln-fam').forEach(function (fam) {
      var a = fam.querySelector('.ln-fam__media');
      var url = a && vids[handleFromUrl(a.getAttribute('href'))];
      if (url) attachVideo(a, url, true, fam);
    });
    var own = vids[handleFromUrl(window.location.pathname)];
    if (own) attachVideo(document.querySelector('.product__media-item .product__media'), own, false, null, true);
    if (vids.hero) attachVideo(document.querySelector('.ln-hero__media'), vids.hero, false, null, true);
  }

  /* ---------- Customer videos: silent previews, full video with sound on tap ---------- */
  function initUgc(root) {
    if (root.__lnUgc) return;
    root.__lnUgc = true;
    if (!reduceMotion && !saveData) {
      root.querySelectorAll('[data-ln-ugc-preview]').forEach(function (box) {
        attachVideo(box, box.getAttribute('data-ln-ugc-preview'), false);
      });
    }
    var dlg = root.querySelector('[data-ln-ugc-dialog]');
    if (!dlg || !dlg.showModal) return;
    var player = dlg.querySelector('video');
    var opener = null;
    function close() { player.pause(); player.removeAttribute('src'); player.load(); if (dlg.open) dlg.close(); if (opener) opener.focus(); }
    root.querySelectorAll('[data-ln-ugc-full]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        opener = btn;
        player.src = btn.getAttribute('data-ln-ugc-full');
        dlg.showModal();
        var p = player.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
    dlg.querySelector('[data-ln-ugc-close]').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  }

  function initShelf(sh) {
    if (sh.__lnShelf || reduceMotion || !('IntersectionObserver' in window)) return;
    sh.__lnShelf = true;
    sh.classList.add('ln-shelf--anim');
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { sh.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.25 });
    io.observe(sh);
  }

  function initGlyphs() {
    document.querySelectorAll('[data-ln-shelf]').forEach(initShelf);
    initCarve();
    initMarquees();
    initVideos();
    document.querySelectorAll('[data-ln-ugc]').forEach(initUgc);
    document.querySelectorAll('.ln-band--ink').forEach(initChamber);
    addScentGlyphs(document);
  }

  /* The bar at the top shows whichever offer is running (dates in ln-config), else its own text */
  function initCampaign() {
    var list = (cfg.offers && cfg.offers.campaigns) || [];
    var ar = /^ar/.test(cfg.lang || '');
    for (var i = 0; i < list.length; i++) {
      if (!within(list[i])) continue;
      document.querySelectorAll('[data-ln-announce]').forEach(function (el) { el.textContent = ar ? list[i].ar : list[i].en; });
      return;
    }
  }

  function init() {
    initCampaign();
    initNotice();
    initMega();
    initGlyphs();
    document.querySelectorAll('[data-ln-delivery]').forEach(initDelivery);
    document.querySelectorAll('[data-ln-engrave]').forEach(initEngrave);
    document.querySelectorAll('[data-ln-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-ln-try-root]').forEach(initTry);
    initPairButtons();
    enhanceCards(document);
    getCart().then(decorateDrawer).catch(function () {});
    watchDrawer();
    if (tierActive) refreshTiers();
    if (window.MutationObserver) {
      var ct;
      var ours = function (n) {
        return n.nodeType !== 1 || (n.classList && (n.classList.contains('ln-vid') || n.classList.contains('ln-scent-glyph') ||
          n.classList.contains('ln-chamber__dust') || n.classList.contains('ln-chamber__torch')));
      };
      new MutationObserver(function (recs) {
        var relevant = recs.some(function (r) { return Array.prototype.some.call(r.addedNodes, function (n) { return !ours(n); }); });
        if (!relevant) return;
        clearTimeout(ct); ct = setTimeout(function () { enhanceCards(document); initGlyphs(); }, 100);
      })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
    if (tierActive && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshTiers);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
